import { BrowserModule } from '@angular/platform-browser';
import { APP_ID, Inject, LOCALE_ID, NgModule, PLATFORM_ID } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { isPlatformBrowser, registerLocaleData } from '@angular/common';
import localeRuUa from '@angular/common/locales/ru-UA';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CartService } from './shared/services/cart.service';
import { LocalStorageService } from './shared/services/local-storage.service';
import { CookieService } from 'ngx-cookie-service';
import { SharedInterceptorModule } from './shared/modules/shared-interceptor.module';

registerLocaleData(localeRuUa, 'ru-UA');

@NgModule({
    declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        HttpClientModule,
        SharedInterceptorModule
    ],
    providers: [
        CartService,
        CookieService,
        LocalStorageService,
        {
            provide: LOCALE_ID, useValue: 'ru_UA'
        }
    ]
})
export class AppModule {
  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    @Inject(APP_ID) private appId: string) {
    const platform = isPlatformBrowser(platformId) ?
      'in the browser' : 'on the server';
  }
}
